import "@/site.css";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import MarketingSite from "@/components/site/MarketingSite";
import AssetsPage from "@/components/site/AssetsPage";
import HowItWorks from "@/components/site/HowItWorks";
import LeadsDashboard from "@/components/site/LeadsDashboard";
import GapAnalysisForm from "@/components/site/GapAnalysisForm";
import Flyer from "@/components/site/Flyer";
import GapAnalysisPages from "@/components/site/GapAnalysisPages";
import WhitePaper from "@/components/site/WhitePaper";
import Proposal2SFG from "@/components/site/Proposal2SFG";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MarketingSite />} />
        <Route path="/assets" element={<AssetsPage />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/gap-analysis" element={<GapAnalysisForm />} />
        <Route path="/gap-analysis-pages" element={<GapAnalysisPages />} />
        <Route path="/whitepaper" element={<WhitePaper />} />
        <Route path="/whitepaper/born-intelligent" element={<WhitePaper />} />
        <Route path="/proposal/2sfg" element={<Proposal2SFG />} />
        <Route path="/proposal/2-sisters" element={<Proposal2SFG />} />
        <Route path="/flyer" element={<Flyer />} />
        <Route path="/marketing" element={<Flyer />} />
        <Route path="/leads" element={<LeadsDashboard />} />
      </Routes>
      <Toaster position="bottom-right" />
    </BrowserRouter>
  );
}

export default App;
